<div *ngIf="userInfo">
    <div *ngIf="isAuthorized()">
        <router-outlet></router-outlet>
    </div>
</div>
